module.exports = __webpack_public_path__ + "static/media/close_gray.23f67e69.svg";